<template>
  <div>


    <div class="container py-3">
      <div class="p-3 bg-white rounded shadow mb-5">

        <div class="row">
          <div class="col-12">

            <div class="d-flex mb-3">
              <h4 class="text-dark font-weight-bolder mr-auto mb-0" v-for="crew_full_name in crewFullName">
                <span><u>{{ crew_full_name }}</u></span>
              </h4>

              <div>
                <button class="btn btn-secondary mb-0" @click="goBack">
                  <font-awesome-icon icon="chevron-left" />
                  Back
                </button>
              </div>
            </div>


            <table class="table table-hover">
              <thead class="thead-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Log Date</th>
                <th scope="col">Operating System</th>
                <th scope="col">IP</th>
                <th scope="col">Device</th>
                <th scope="col">Browser</th>
                <th scope="col">Browser Version</th>
                <th scope="col">Action</th>
              </tr>
              </thead>

              <tbody v-if="isLoading">
              <tr>
                <td colspan="100%">
                  <base-loader></base-loader>
                </td>
              </tr>
              </tbody>

              <tbody v-else>
              <tr v-for="(crew_logs,index) in crewLogs" :key="crew_logs.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ eliteDateFormat(crew_logs.log_date) }}</td>
                <td>{{ crew_logs.os }}</td>
                <td>{{ crew_logs.ip }}</td>
                <td>{{ crew_logs.device }}</td>
                <td>{{ crew_logs.browser }}</td>
                <td>{{ crew_logs.browser_version }}</td>
                <td>
                  <button class="btn btn-dark btn-sm" style="font-size: 12px;" @click="viewActivity(crew_logs.id)"
                          v-if="crew_logs.crew_count_log_activity !== 0">
                    <font-awesome-icon icon="eye" />
                    View
                    Activity
                  </button>

                  <button class="btn btn-danger btn-sm" style="font-size: 12px;"
                          v-if="crew_logs.crew_count_log_activity === 0">
                    <font-awesome-icon icon="eye-slash" />
                    No Activity
                  </button>
                </td>
              </tr>
              </tbody>
            </table>


          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 d-flex d-flex justify-content-center">
            <base-pagination :page-object="crewPagination" @settingPage="setPage"></base-pagination>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {AppMixins} from '@/mixins/app.mixins';
import {mapActions, mapGetters} from 'vuex';
import {AppService} from '@/service/app.service';

export default {
  name: 'CrewLog',

  /** mixins **/
  mixins: [AppMixins],

  /** data **/
  data() {
    return {
      crewId: this.$route.params.crewId,
      formCrewData: {
        page: 1,
        perPage: 10,
      },
    };
  },

  /** methods**/
  methods: {
    ...mapActions([
      'getCrewLogs',
      'viewCrewLogActivity',
    ]),

    viewActivity(__crewLogId) {
      this.viewCrewLogActivity(__crewLogId);
      this.$nextTick(() => {
        this.$router.push({name: 'CrewActivity', params: {crewLogId: __crewLogId}});
      });
    },

    eliteDateFormat(date) {
      return AppService.dateEliteFormat(date);
    },

    setPage(e) {
      this.formCrewData.page = e;
      this.updateParams();
    },

    async updateParams() {
      await this.getCrewLogs(this.formCrewData);
    },

  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'crewLogs',
          'isLoading',
          'crewPagination',
        ],
    ),

    crewFullName: function() {
      let remove_duplicate = [];
      for (let i = 0; i < this.crewLogs.length; i++) {
        if (remove_duplicate.indexOf(this.crewLogs[i].crew_full_name) === -1) {
          remove_duplicate.push(this.crewLogs[i].crew_full_name);
        }
      }
      return remove_duplicate;
    },

  },

  /** created **/
  created() {
    this.getCrewLogs({id: this.crewId});
    this.formCrewData.id = this.crewId;
  },

};
</script>

<style scoped>

</style>
